export interface ShipplayTermsContent {
  title: string
}

export const shipplayContent: ShipplayTermsContent = {
  title: 'Terms of Use',
}
